<span
  class="munily-avatar"
  [ngClass]="avatarClasses"
  [style.background-color]="backgroundColor || null"
>
  <img
    *ngIf="imageUrl"
    class="munily-avatar__img"
    [src]="imageUrl"
    [alt]="alt"
    [style.object-fit]="objectFit"
  />
  <span *ngIf="!imageUrl && displayInitials" class="munily-avatar__initials">
    {{ displayInitials }}
  </span>
</span>
